/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingCenterUI } from './BookingCenterUI';
import {
    BookingCenterUIFromJSON,
    BookingCenterUIFromJSONTyped,
    BookingCenterUIToJSON,
    BookingCenterUIToJSONTyped,
} from './BookingCenterUI';

/**
 * 
 * @export
 * @interface AccountInformation
 */
export interface AccountInformation {
    /**
     * Account number - 8 digits with leading zeros (0) if less than 8 digits
     * @type {string}
     * @memberof AccountInformation
     */
    account?: string;
    /**
     * List of the names of the account holders
     * @type {Array<string>}
     * @memberof AccountInformation
     */
    accountHolders?: Array<string>;
    /**
     * 
     * @type {BookingCenterUI}
     * @memberof AccountInformation
     */
    bookingCenter?: BookingCenterUI;
}



/**
 * Check if a given object implements the AccountInformation interface.
 */
export function instanceOfAccountInformation(value: object): value is AccountInformation {
    return true;
}

export function AccountInformationFromJSON(json: any): AccountInformation {
    return AccountInformationFromJSONTyped(json, false);
}

export function AccountInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : json['account'],
        'accountHolders': json['accountHolders'] == null ? undefined : json['accountHolders'],
        'bookingCenter': json['bookingCenter'] == null ? undefined : BookingCenterUIFromJSON(json['bookingCenter']),
    };
}

export function AccountInformationToJSON(json: any): AccountInformation {
    return AccountInformationToJSONTyped(json, false);
}

export function AccountInformationToJSONTyped(value?: AccountInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'accountHolders': value['accountHolders'],
        'bookingCenter': BookingCenterUIToJSON(value['bookingCenter']),
    };
}

